/**
 * Uppy 5.x TypeScript type helpers
 * 
 * These types provide proper generics for Uppy 5.x integration across all projects.
 * Use these instead of raw Uppy types to ensure consistency.
 */

import Uppy from "@uppy/core";
import type { UppyFile, UploadResult } from '@uppy/core';
import type { DashboardOptions } from '@uppy/dashboard';

export type DefaultMeta = Record<string, never>;
export type DefaultBody = Record<string, never>;

export type AppUppy = Uppy<DefaultMeta, DefaultBody>;
export type AppUppyFile = UppyFile<DefaultMeta, DefaultBody>;
export type AppUploadResult = UploadResult<DefaultMeta, DefaultBody>;
export type AppDashboardOptions = DashboardOptions<DefaultMeta, DefaultBody>;

export interface UppyConfig {
  restrictions?: {
    maxFileSize?: number;
    maxNumberOfFiles?: number;
    allowedFileTypes?: string[];
  };
  autoProceed?: boolean;
  debug?: boolean;
  locale?: {
    strings?: Record<string, string>;
    pluralize?: (count: number) => number;
  };
}
